import React, { Component } from 'react';

//styles
import '../RosterScheduler/css/workPatternStyle.css';

class PatternStartWeekEmployeeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canScrollLeft: false,
            canScrollRight: false,
        };
        this.tabsRef = React.createRef();
        this._scrollTimer = null;
    }

    componentWillUnmount() {
        clearTimeout(this._scrollTimer);
    }

    componentDidUpdate(prevProps) {
        const prevWeekCount = prevProps.weekCount || 1;
        const currWeekCount = this.props.weekCount || 1;
        if (prevWeekCount !== currWeekCount) {
            this.checkScroll();
        }
        if (prevProps.activeWeek !== this.props.activeWeek) {
            this.checkScroll();
        }
    }

    componentDidMount() {
        this.checkScroll();
    }

    checkScroll = () => {
        const el = this.tabsRef.current;
        if (!el) return;
        this.setState({
            canScrollLeft: el.scrollLeft > 0,
            canScrollRight: el.scrollLeft + el.clientWidth < el.scrollWidth - 1,
        });
    };

    scrollTabs = (dir) => {
        const el = this.tabsRef.current;
        if (!el) return;
        el.scrollBy({ left: dir * 160, behavior: 'smooth' });
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(this.checkScroll, 300);
    };

    render() {
        const { weekCount, activeWeek, onWeekTabClick, weekCounts, t } = this.props;
        const { canScrollLeft, canScrollRight } = this.state;
        const weeks = weekCount || 1;

        if (weeks <= 1) return null;

        return (
            <div className="pattern-week-tabs-wrapper position-relative border border-bottom-0 rounded-top bg-light">
                <button
                    type="button"
                    className={`pattern-week-arrow pattern-week-arrow-left d-flex align-items-center justify-content-center border-0 p-0${canScrollLeft ? ' visible' : ''}`}
                    onClick={() => this.scrollTabs(-1)}
                    tabIndex={-1}
                >
                    <i className="fa fa-chevron-left" />
                </button>

                <div
                    className="pattern-week-tabs d-flex flex-nowrap"
                    ref={this.tabsRef}
                    onScroll={this.checkScroll}
                >
                    {Array.from({ length: weeks }, (_, i) => i + 1).map(w => (
                        <button
                            key={w}
                            type="button"
                            className={`pattern-week-tab d-flex align-items-center justify-content-center flex-shrink-0 border-0 border-end fw-semibold text-nowrap${activeWeek === w ? ' active' : ' text-secondary'}`}
                            onClick={() => onWeekTabClick && onWeekTabClick(w)}
                        >
                            {t('Start')} {t('Week')} {w}
                            {weekCounts && weekCounts[w] > 0 && (
                                <span className="pattern-week-count d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold lh-1 flex-shrink-0 ms-1">
                                    {weekCounts[w]}
                                </span>
                            )}
                        </button>
                    ))}
                </div>

                <button
                    type="button"
                    className={`pattern-week-arrow pattern-week-arrow-right d-flex align-items-center justify-content-center border-0 p-0${canScrollRight ? ' visible' : ''}`}
                    onClick={() => this.scrollTabs(1)}
                    tabIndex={-1}
                >
                    <i className="fa fa-chevron-right" />
                </button>
            </div>
        );
    }
}

export default PatternStartWeekEmployeeSelect;
